import * as React from 'react';

export const InnerPageLayoutContent: React.FC = ({ children }) => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
);
